import { ReactElement, useContext } from "react"

import { NON_SYS_ADMIN_EVAC_STEPS_AMEND } from "../../../../../constants/lct/evac/deviceForm"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { AmendEVACDeviceContext } from "../providers/baseProviders/amendEVACDeviceProvider"

/** AppStepper for amending an EVAC device */
const AmendEvacDeviceProgressStepper = (): ReactElement => {
    const { currentIndex } = useContext(AmendEVACDeviceContext)

    return (
        <AppStepper
            stepLabels={NON_SYS_ADMIN_EVAC_STEPS_AMEND}
            currentStepIndex={currentIndex}
        />
    )
}

export default AmendEvacDeviceProgressStepper
